import { Alert, Button } from "@mantine/core";
import { IconAlertTriangle, IconArrowRight } from "@tabler/icons";
import { signIn } from "next-auth/react";

const LoginAlert = ({
    description = "You must be signed in, inorder to track your performance and compare ranks with others.",
}) => {
    return (
        <Alert
            color={"red"}
            icon={<IconAlertTriangle />}
            title={"You're not Logged in"}
            variant="outline"
            radius={"lg"}
        >
            {description}

            <Button
                variant="subtle"
                color={"green"}
                onClick={signIn}
                rightIcon={<IconArrowRight />}
            >
                Login Now
            </Button>
        </Alert>
    );
};

export default LoginAlert;
